/**
 * A typed default variable of a No-Codes screen, configured in the builder and delivered
 * at screen load so it can be read by key. The value keeps its authored type
 * (boolean / string / number) rather than being coerced to a string.
 */
export class NoCodesScreenVariable {
    constructor(kind, key, type, value, stringValue) {
        this.kind = kind;
        this.key = key;
        this.type = type;
        this.value = value;
        this.stringValue = stringValue;
    }
}
/**
 * A loaded No-Codes screen returned from {@link NoCodesApi.loadScreen}.
 *
 * Exposes the screen identifiers and the typed default variables configured in the builder —
 * the screen content stays internal, as rendering remains the SDK's job via
 * {@link NoCodesApi.showScreen}.
 */
export class NoCodesScreen {
    constructor(id, contextKey, defaultSelectedProductId, defaultVariables) {
        this.id = id;
        this.contextKey = contextKey;
        this.defaultSelectedProductId = defaultSelectedProductId;
        this.defaultVariables = defaultVariables;
    }
    /**
     * Returns the default variable configured under the given key, or undefined when the screen
     * has no variable with that exact (case-sensitive) key.
     *
     * Keys are only unique within a kind — a custom variable and a product slot may share a
     * name — so pass `kind` to disambiguate; without it the first match in payload order
     * (custom variables, then product slots, then the selected product) is returned.
     *
     * For the default selected product prefer {@link defaultSelectedProductId} — it needs no key.
     */
    defaultVariable(key, kind) {
        return this.defaultVariables.find(variable => variable.key === key && (kind === undefined || variable.kind === kind));
    }
}
//# sourceMappingURL=NoCodesScreen.js.map